import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { TokboxComponent } from './tokbox/tokbox-viewer/tokbox.viewer.component';
import { PublisherComponent } from './tokbox/publisher/publisher.component';
import { SubscriberComponent } from './tokbox/subscriber/subscriber.component';
import { ApportisCommonModule } from '../common';
import { BackButtonDisableModule } from 'angular-disable-browser-back-button';
import { RouterModule } from '@angular/router';
import { videoroutes } from './video.routing';
import { CallInvitationComponent } from './call-invitation/call-invitation.component';


@NgModule({
    declarations: [
        TokboxComponent,
        PublisherComponent,
        SubscriberComponent,
        CallInvitationComponent
    ],
    imports: [
        CommonModule,
        RouterModule.forChild(videoroutes),
        MatProgressSpinnerModule,
        ApportisCommonModule,
        BackButtonDisableModule.forRoot({
            preserveScrollPosition: true
          })

    ],
    exports: [
    ],
    providers: [],
})
export class VideoModule { }
